import { MutationTree } from 'vuex';
import { CustomQuestionsState } from '../types';
import { decodeCustomQuestion } from '@/utils/decoding';
import Vue from 'vue';

export const mutations: MutationTree<CustomQuestionsState> = {
	SET_CUSTOM_QUESTIONS(state, questions: CustomQuestion[]): void {
		Vue.set(state, 'questions', questions.map(decodeCustomQuestion));
	},

	SET_CUSTOM_FIELDS(state, fields: CustomQuestion[]): void {
		Vue.set(state, 'customFields', fields);
	},

	ADD_CUSTOM_FIELD(state, field: CustomQuestion): void {
		Vue.set(state, 'customFields', [...state.customFields, field]);
	},

	REMOVE_CUSTOM_FIELD(state, index: number): void {
		state.customFields.splice(index, 1);
	},

	SET_CUSTOM_FIELDS_INITIALIZED(state, initialized: boolean): void {
		Vue.set(state, 'customFieldsInitialized', initialized);
	},

	RESET_CUSTOM_FIELDS(state): void {
		Vue.set(state, 'customFields', []);
		Vue.set(state, 'customFieldsInitialized', false);
	}
};
